module.exports = __webpack_public_path__ + "img/stock0.15716d71.png";